<template>
  <div class="wrap">
    <div class="d-flex justify-content-center align-items-center" style="gap: .85rem">
      <span class="column-action-button bg-light d-flex justify-content-center align-items-center border" @click="$emit('details', { component: 'RoleDetails', value:value })">
        <i class="mdi mdi-eye-off-outline cursor-pointer" v-if="!showDetails" ></i>
        <i class="mdi mdi-eye-outline cursor-pointer" v-if="showDetails" ></i>
      </span>
      <div class="ml-2">
        {{value.name}}
      </div>
      <div class="ml-auto flex items-center">
        <div
          class="cursor-pointer flex items-center gap-1 px-2 py-1 rounded-full bg-gray-200 text-xs text-gray-600"
          @click="$emit('details', { component: 'RoleDetails', value:value })"
        >
          <span class="font-bold">{{ value.privileges.length }}</span>
          <span>Privilegios</span>
        </div>
      </div>
      <div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    showDetails: {
      type: Boolean,
      required: false
    }
  }
}
</script>
<style scoped>
.wrap {
  display: flex;
  align-items: center;
}
button {
  margin-right: 5px;
}
.wrap-badges {
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
}
.column-action-button {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  padding: 4px;
}
</style>
